import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import {
  isRadiusSupportedBrand,
  RouterBrand,
  RouterBrandEnum,
  RouterBrandInterface,
} from "src/app/shared/enum/routerBrand";
import { REQUIRED_WHEN_ERROR } from "src/app/shared/validators/required-when.validator";

@Component({
  selector: "app-router-information",
  templateUrl: "./router-information.component.html",
})
export class RouterInformationComponent implements OnInit {
  @Input("form") form: FormGroup;

  routerBrand: RouterBrandInterface[];
  selectedRouterBrands: RouterBrand[] = [];
  showRadPassword: boolean = false;
  constructor() {}

  get isRadiusSupported(): boolean {
    return isRadiusSupportedBrand(this.form.get("routerBrand")?.value);
  }

  get isRadiusEnabled(): boolean {
    return this.form.get("radiusEnabled")?.value === true;
  }

  ngOnInit(): void {
    this.selectedRouterBrands = [
      ...this.selectedRouterBrands,
      this.form.get("routerBrand")?.value,
    ];

    this.routerBrand = Object.keys(RouterBrand)
      .filter((value) => isNaN(Number(value)) === true)
      .map((key: string | any) => ({
        id: RouterBrand[key as keyof typeof RouterBrand],
        value: RouterBrandEnum[key as keyof typeof RouterBrand].name,
        icon: RouterBrandEnum[key as keyof typeof RouterBrand].icon,
      }));
  }

  addRemoveRouterBrand(event: Event, routerBrand: RouterBrand): void {
    event.preventDefault();

    if (this.selectedRouterBrands.length == 0) {
      this.selectedRouterBrands.push(routerBrand);
    } else {
      for (let i = 0; i < this.selectedRouterBrands.length; i++) {
        if (this.selectedRouterBrands[i] != routerBrand) {
          this.selectedRouterBrands.pop();
          this.selectedRouterBrands.push(routerBrand);
        } else {
          this.selectedRouterBrands.splice(i);
        }
      }
    }
    this.form.patchValue({ routerBrand: this.selectedRouterBrands[0] });
    if (!this.isRadiusSupported) {
      this.form.patchValue({ radiusEnabled: false });
    }
  }

  routerBrandExists(routerBrand: RouterBrand): boolean {
    return this.selectedRouterBrands.includes(routerBrand);
  }

  toggleRadPasswordVisibility(): void {
    this.showRadPassword = !this.showRadPassword;
  }

  isRadiusCredentialMissing(controlName: string): boolean {
    const missingControlNames: string[] = this.form.errors?.[REQUIRED_WHEN_ERROR] ?? [];
    return (
      missingControlNames.includes(controlName) &&
      !!this.form.get(controlName)?.touched
    );
  }
}
